import { createAction } from 'redux-actions'

export const setNavbarDefaultState = createAction('SET_NAVBAR_DEFAULT_STATE')
export const resetNavbarState = createAction('RESET_NAVBAR_STATE')
export const switchPanel = createAction('SWITCH_PANEL', (panel, location) => ({ panel, location }))
